// extracted by mini-css-extract-plugin
export default {"wrapper":"messageBox_wrapper__2ZyKt","message":"messageBox_message__zydxQ","icon":"messageBox_icon__FOIaZ"};